import { render, staticRenderFns } from "./formula_edit.vue?vue&type=template&id=35216361&scoped=true"
import script from "./formula_edit.vue?vue&type=script&lang=js"
export * from "./formula_edit.vue?vue&type=script&lang=js"
import style0 from "./formula_edit.vue?vue&type=style&index=0&id=35216361&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35216361",
  null
  
)

export default component.exports